import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import AddressesMapView from './components/AddressesMapView';

/** CT / CTS global map: every quota location address across all projects. */
const MANAGE_ROLES = ['chef_terrain', 'chef_terrain_superieur', 'administrateur_general', 'administrateur_general_superieur', 'admin_it'];

const StaffAddressesMap = () => {
  const { user } = useAuth();
  return (
  <AddressesMapView
    endpoint="/quotas/locations/all"
    showSupervisor
    allowVisitedToggle
    visitedBase="/quotas/locations"
    allowDelete
    title="Carte des adresses (tous les projets)"
    subtitle="Tous les emplacements de tous les projets de quota, par prestataire."
    showNotes
    canEditNotes={MANAGE_ROLES.includes(user?.role)}
  />
  );
};

export default StaffAddressesMap;
